module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "fr-wrap fr"
  }, [_vm._m(2), _vm._v(" "), (!_vm.isLogin) ? _c('div', {
    staticClass: "btn-wrap",
    attrs: {
      "id": "unlogin"
    }
  }, [_c('button', {
    staticClass: "fl",
    on: {
      "click": function($event) {
        _vm.showObj.login = true
      }
    }
  }, [_vm._v("登录")]), _vm._v(" "), _c('button', {
    staticClass: "fl",
    on: {
      "click": function($event) {
        _vm.showObj.register = true
      }
    }
  }, [_vm._v("注册")])]) : _vm._e(), _vm._v(" "), (_vm.isLogin) ? _c('div', {
    staticClass: "info-wrap",
    attrs: {
      "id": "islogin"
    }
  }, [_c('div', {
    staticClass: "my-info"
  }, [_c('img', {
    attrs: {
      "src": "http://www.evhui.com/wp-content/themes/evhui3.0/public/images/nophoto.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "logout",
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_c('span'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("退出登录")])])])])]) : _vm._e()])]), _vm._v(" "), _c('Register', {
    attrs: {
      "showObj": _vm.showObj
    }
  }), _vm._v(" "), _c('Login', {
    attrs: {
      "showObj": _vm.showObj
    },
    on: {
      "userLogin": _vm.judgeLogin
    }
  }), _vm._v(" "), _c('Changepwd', {
    attrs: {
      "showObj": _vm.showObj
    }
  }), _vm._v(" "), _c('Qrcode', {
    attrs: {
      "showObj": _vm.showObj
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo fl"
  }, [_c('img', {
    attrs: {
      "src": "http://www.evhui.com/wp-content/themes/evhui3.0/public/images/logo.png",
      "alt": "电车汇"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav fl"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "http://www.evhui.com/"
    }
  }, [_vm._v("首页")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "line-height": "100px",
      "transition": "all 0.4s ease"
    },
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("分类")]), _c('span'), _vm._v(" "), _c('ul', {
    staticStyle: {
      "top": "100px",
      "transition": "all 0.4s ease"
    }
  }, [_c('li', {
    attrs: {
      "onclick": "window.location.href='http://www.evhui.com/category/info'"
    }
  }, [_c('em', {
    staticClass: "icon_info_small fl"
  }), _vm._v("讯息")]), _vm._v(" "), _c('li', {
    attrs: {
      "onclick": "window.location.href='http://www.evhui.com/category/voice'"
    }
  }, [_c('em', {
    staticClass: "icon_voice_small fl"
  }), _vm._v("声音\n                    ")]), _vm._v(" "), _c('li', {
    attrs: {
      "onclick": "window.location.href='http://www.evhui.com/category/newdeal'"
    }
  }, [_c('em', {
    staticClass: "icon_newdeal_small fl"
  }), _vm._v("新政\n                    ")]), _vm._v(" "), _c('li', {
    attrs: {
      "onclick": "window.location.href='http://www.evhui.com/category/industry'"
    }
  }, [_c('em', {
    staticClass: "icon_industry_small fl"
  }), _vm._v("产业\n                    ")]), _vm._v(" "), _c('li', {
    attrs: {
      "onclick": "window.location.href='http://www.evhui.com/category/evaluating'"
    }
  }, [_c('em', {
    staticClass: "icon_evaluating_small fl"
  }), _vm._v("评测\n                    ")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://car.evhui.com/"
    }
  }, [_vm._v("电车库")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "line-height": "100px",
      "transition": "all 0.4s ease"
    },
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("资源")]), _c('span'), _vm._v(" "), _c('ul', {
    staticClass: "nav2_long",
    staticStyle: {
      "top": "100px",
      "transition": "all 0.4s ease"
    }
  }, [_c('li', {
    attrs: {
      "onclick": "window.location.href='http://www.evhui.com/policy'"
    }
  }, [_c('em', {
    staticClass: "icon_file_small fl"
  }), _vm._v("政策规划库")]), _vm._v(" "), _c('li', {
    attrs: {
      "onclick": "window.location.href='http://www.evhui.com/standard'"
    }
  }, [_c('em', {
    staticClass: "icon_standard_small fl"
  }), _vm._v("行业标准库")]), _vm._v(" "), _c('li', {
    attrs: {
      "onclick": "window.location.href='http://www.evhui.com/reportlist'"
    }
  }, [_c('em', {
    staticClass: "icon_report_small fl"
  }), _vm._v("数据图表报告")]), _vm._v(" "), _c('li', {
    attrs: {
      "onclick": "window.location.href='http://tool.evhui.com/hotlist'"
    }
  }, [_c('em', {
    staticClass: "icon_subsidies_small fl"
  }), _vm._v("补贴免税查询")]), _vm._v(" "), _c('li', {
    attrs: {
      "onclick": "window.location.href='http://tool.evhui.com/'"
    }
  }, [_c('em', {
    staticClass: "icon_subsidies_small fl"
  }), _vm._v("产销数据查询")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://list.qq.com/cgi-bin/qf_invite?id=1b75588466e4e916a9db719ea41bdde3c3a718745a158c52"
    }
  }, [_vm._v("订阅")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search fl"
  }, [_c('img', {
    staticClass: "fr",
    attrs: {
      "src": "http://www.evhui.com/wp-content/themes/evhui3.0/public/images/search.jpg",
      "width": "40",
      "height": "40",
      "alt": ""
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "search-txt fr",
    attrs: {
      "type": "text",
      "placeholder": "请输入搜索内容……"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08fadd32"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 566
// module chunks = 1